import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2022-11-22T11:00",
		title: `
<h4>新潟県医師会在宅医療推進センターより</h4>
<p class="paragraph-indent">
●第９回甲信越在宅医療推進フォーラム（第14回在宅ケアを考える集いin 越後2022）を11月６日（日）に開催いたしました。<br>
YouTubeにてライブ配信した動画を公開しています。<br>
・<a href="https://www.youtube.com/watch?v=PHCAxyeLJco">動画URL</a>
・<a href="${topicsDir}/2022/11-14thzaitaku-care.pdf">抄録集</a><br>
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2022-11-25T11:00",
		title: `
<h4>新潟県医師会在宅医療推進センターより</h4>
<p class="paragraph-indent">
●第9回新潟県在宅医療推進センターコーディネーター研修会を11月24日（木）に開催いたしました。<br>
<em>テーマ：</em>退院時の連携は何のために～目的を意識したPDCAを考える～<br>
<em>講師：</em>公立大学法人埼玉県立大学大学院　<br data-mq="sp"><span data-mq="sp">　　　</span>保健医療福祉学研究科／<br><span>　　　</span>研究開発センター　教授　<br data-mq="sp"><span data-mq="sp">　　　</span>川越雅弘様<br>
講義と演習により、コーディネーターとしてこの事業にどう向き合えばよいのかを皆で考え、深い学びの機会となりました。
</p>
<div class="imageBox-3">
<ul><li><img src="../../../zaitaku/contents/topics/2022/11-002/img01.png" alt="第9回新潟県在宅医療推進センターコーディネーター研修会"></li></ul>
<ul><li><img src="../../../zaitaku/contents/topics/2022/11-002/img02.png" alt="第9回新潟県在宅医療推進センターコーディネーター研修会"></li></ul>
<ul><li><img src="../../../zaitaku/contents/topics/2022/11-002/img03.png" alt="第9回新潟県在宅医療推進センターコーディネーター研修会"></li></ul>
</div>
		`.trim().replace(/\t|\n/g, "")
	}
];
